import React, { useEffect } from 'react'
import styles from "./About.module.css"
import dummy from "../../assets/dummy.jpg"
import introImage from "../../assets/intro.png"
import Sidelogo from "../../assets/Sidelogo.png"
import AboutUs from '../../Components/About/About'
import AnimiatedPage from '../../AnimiatedPage'
import Contact from '../../Components/Contact/Contact'


function About() {
    useEffect(()=>{
    document.title = 'SHARVIL Business Group-About Us'
    },[])
    return (
        <AnimiatedPage>
            <div className={styles.aboutUs}>
                <div className={styles.aboutHead}>
                    <h3>我々について <span>ABOUT US</span></h3>
                </div>

                <div className={styles.introduction}>
                    <div className={styles.introImage}>
                        <img src={dummy} alt="" />

                    </div>
                    <div className={styles.introImageMobile}>
                        <img src={Sidelogo} alt="" />

                    </div>
                    <div className={styles.introPara}>
                        <p>想像を現実に。このアイデアが弊グループの根本にあります。IT技術をバックボーンに成長したことが背景にあることから、ビジネスにおいて発生する課題とその解決方法の例を世界中のクライアントとの協力をもとに見てきました。想像した解決策は、想像できている時点で実現できることがほとんどなのです。その信念をもとに、技術の枠組み、既存のビジネスの枠組みに捉われずに思考し、それらを実現する力が弊グループの他社にはない強みです。</p>
                    </div>
                </div>

                <div className={styles.comanyName}>

                    {/* <img src={introImage} alt="Company Info" /> */}
                    <h1>COMPANY</h1>
                    <p>SHARVIL Business Group</p>
                    <h1>LOCATION</h1>
                    <p>Japan-Tokyo,Kyoto,Kobe <br /> India</p>
                    <h1>OUR TEAM</h1>
                    <p>50+ members all over the world</p>


                </div>

                <AboutUs about />

                <Contact />
                <div className={styles.bottomRightMidCircle}></div>
                <div className={styles.bottomCircle}></div>
                <div className={styles.bottomRightCircle}></div>
                <div className={styles.bottomLeftCircle}></div>
                <div className={styles.bottomLeftSideCircle}></div>
            </div>
        </AnimiatedPage>
    )
}

export default About